var chatClient = angular.module('chatClient', []);
var presenterChatClient = angular.module('presenterChatClient', []);
var attendeeList = angular.module('attendeeList', []);
var conferenceClient = angular.module('conferenceClient', []);
var videoroomClient = angular.module('videoroomClient', []);
var screenSharePresenter = angular.module('screenSharePresenter', []);
var videoPlayerControls = angular.module('videoPlayerControls', []);
var slideShowPresenter = angular.module('slideShowPresenter', []);
var webinarAttendeeQuestionSubmitControl = angular.module('webinarAttendeeQuestionSubmitControl', []);
var qaPresenter = angular.module('qaPresenter', []);
var pollsPresenter = angular.module('pollsPresenter', []);
var meetingActive = angular.module('meetingActive', []);
var circleLoader = angular.module('circleLoader', []);
//TODO: testing line
//window.cordova = true;

var firebird = angular.module(
    'firebird',
    [
        'ngResource',
        'ui.router',
        'ngAnimate',
        'ct.ui.router.extras',
        'angular-loading-bar',
        'oc.lazyLoad',
        'ngSanitize',
        'dbaq.emoji',
        'ngCookies',
        'ngPromiseExtras',
        'chatClient',
        'presenterChatClient',
        'attendeeList',
        'conferenceClient',
        'videoroomClient',
        'screenSharePresenter',
        'ngFileUpload',
        'videoPlayerControls',
        'webinarAttendeeQuestionSubmitControl',
        'qaPresenter',
        'slideShowPresenter',
        'pollsPresenter',
        'angulartics',
        'angulartics.heap',
        'angulartics.pendo',
        'angulartics.google.analytics',
        'rzModule',
        'angularResizable',
        'window-events',
        'angular-click-outside',
        'vs-repeat',
        'hmTouchEvents',
        'pascalprecht.translate',
        'circleLoader',
        'meetingActive'
        //'angulartics.debug'
    ],
    [
        '$translateProvider',
        '$animateProvider',
        'cfpLoadingBarProvider',
        function ($translateProvider, $animateProvider, cfpLoadingBarProvider) {
            $translateProvider.useMissingTranslationHandler('customTranslationHandler');
            // apply animation to css classes starting from 'am-animate'
            $animateProvider.classNameFilter(/am-animate/);
            // redesign meeting loading spinner
            cfpLoadingBarProvider.spinnerTemplate =
                '<img id="loading-bar-spinner" class="spinnerRedesign" src="img/redesign/icons/loading-spinner.svg">';
        }
    ]
);

firebird.factory('customTranslationHandler', function () {
    return function (translationID, uses) {
        return 'NO TRANSLATION KEY FOUND';
    };
});

//If window error happens before angular loads, this will be called.
//If angular loads, it will overwrite this function with a new one
//that has R7Insight + analytics event logging included
window.onerror = function (err) {
    console.error('Window error:', err);
};

function cordovaHandleOpenURL(launchURL) {
    //If meetingLoginCtrl not yet initiated, it will receive this event after it loads
    cordova.fireDocumentEvent('sticky-handleopenurl', { detail: launchURL });

    //If meetingLoginCtrl already initiated, it will receive this event
    var ev = new CustomEvent('handleopenurl', { detail: launchURL });
    document.dispatchEvent(ev);
}

//Hook for mobile ... only called if cordova exists
if (window.cordova) {
    // Just for Cordova apps.
    document.addEventListener('deviceready', function () {
        // Just for iOS devices.
        if (window.device.platform === 'iOS') {
            cordova.plugins.iosrtc.registerGlobals();
            window.plugins.insomnia.keepAwake();

            //this is to fix keyboard blocking text input area bug
            window.addEventListener('keyboardWillHide', function () {
                window.document.getElementsByTagName('html')[0].style.height = '101vh';
                setTimeout(function () {
                    window.document.getElementsByTagName('html')[0].style.height = '100vh';
                }, 40);
            });
        } else {
            //android
            //overrides back button to background app instead of killing it
            cordova.plugins.backgroundMode.overrideBackButton();
        }

        // For iOS and Android devices.
        if (window.universalLinks && window.universalLinks.subscribe) {
            window.universalLinks.subscribe(null, function (eventData) {
                cordovaHandleOpenURL(eventData.url);
            });
        }
    });

    window.cordova.addStickyDocumentEventHandler('sticky-handleopenurl');
}
